import { createStart } from "@tanstack/react-start";
import { attachSupabaseToken } from "@/integrations/supabase/attach-token-middleware";
import { cacheHeadersMiddleware } from "@/lib/cache-headers-middleware";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

// `attachSupabaseToken` is the project-specific replacement for the generated
// `attachSupabaseAuth` middleware: it does the same bearer-token attachment but
// dynamically imports the Supabase client, keeping supabase-js out of the main
// bundle. Do not re-add `attachSupabaseAuth` — it would duplicate the header
// work and pull supabase-js back into the entry chunk.
export const startInstance = createStart(() => ({
  requestMiddleware: [cacheHeadersMiddleware],
  functionMiddleware: [attachSupabaseAuth, attachSupabaseToken],
}));
